import { useEffect, useRef, useState } from 'react';
import { SHOP_TOAST_EVENT } from '../../utils/shopToast';

function ShopGlobalToast({ preset = 'prominent' }) {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('success');
  const timeoutRef = useRef(null);

  useEffect(() => {
    const handleToast = (event) => {
      const nextMessage = event?.detail?.message || '';
      const nextVariant = event?.detail?.variant || 'success';

      setMessage(nextMessage);
      setVariant(nextVariant);
      setShow(true);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setShow(false);
      }, 3000);
    };

    window.addEventListener(SHOP_TOAST_EVENT, handleToast);

    return () => {
      window.removeEventListener(SHOP_TOAST_EVENT, handleToast);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return (
    <div
      className={`shop-global-toast-wrapper shop-toast-preset-${preset} position-fixed end-0 p-3`}
      aria-live="polite"
      aria-atomic="true"
    >
      <div
        className={`toast align-items-center text-bg-${variant} border-0 ${show ? 'show' : 'hide'}`}
        role="alert"
      >
        <div className="d-flex">
          <div className="toast-body">{message}</div>
          <button
            type="button"
            className={`btn-close ${variant === 'warning' ? '' : 'btn-close-white'} me-2 m-auto`}
            onClick={() => setShow(false)}
            aria-label="Cerrar"
          ></button>
        </div>
      </div>
    </div>
  );
}

export default ShopGlobalToast;
